/**
 * The workspace's Table/Chart tabs, as addressed by the `tab` search param.
 *
 * Which tab is open is a persisted workspace preference (`viewMode` on the DTO) held in the `view$`
 * atom, but it also has to be *addressable*: a deep link — or the assistant's `open_page` tool —
 * must be able to land on the Chart tab of a workspace whose saved view is the table. The optional
 * `tab` param is that address, and it carries the `ViewModeEnum` value itself, like the platform's
 * other `?tab=` params carry theirs.
 */
import { ViewModeEnum } from "@eu.mdotm.api/smart-workspaces";

/** Every accepted `tab` value — also what the `open_page` tool advertises to the model. */
export const workspaceViewTabs = [ViewModeEnum.Table, ViewModeEnum.Chart];

/**
 * The view a `tab` param asks for. `undefined` when the param is absent or unrecognized — an
 * unusable value must fall back to the workspace's persisted view, never blank the page. Casing is
 * ignored: the value gets typed, pasted and generated by hand.
 */
export function viewModeFromTabParam(tab: string | undefined): ViewModeEnum | undefined {
	const candidate = tab?.toUpperCase();
	return workspaceViewTabs.find((view) => view === candidate);
}
